import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

class Wrapper extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClickOutside: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: undefined,
  };

  handleClickOutside = () => {
    this.props.onClickOutside();
  };

  render() {
    const { children, className } = this.props;

    return <span className={className}>{children}</span>;
  }
}

export default onClickOutside(Wrapper);
